import React from 'react';

class ShowTradedCheckbox extends React.Component {

	render() {
        return (
            <div className='field-wrap'>
                <input
                    type='checkbox'
                    name='show_traded'
                    id='show_traded'
                    checked={this.props.value}
                    onChange={this.props.onChange} />
                <label htmlFor='show_traded' className='checkbox-label'>Show as traded on trading screen</label>
            </div>
        )
    }
}

export default ShowTradedCheckbox;



// WEBPACK FOOTER //
// ./source/components/showTraded.js